var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardValidator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.83333 8.25C2.56268 8.25 3.26215 8.53973 3.77788 9.05546C4.2936 9.57118 4.58333 10.2707 4.58333 11C4.58333 11.7293 4.2936 12.4288 3.77788 12.9445C3.26215 13.4603 2.56268 13.75 1.83333 13.75V15.5833C1.83333 16.0696 2.02649 16.5359 2.3703 16.8797C2.71412 17.2235 3.18044 17.4167 3.66667 17.4167H18.3333C18.8196 17.4167 19.2859 17.2235 19.6297 16.8797C19.9735 16.5359 20.1667 16.0696 20.1667 15.5833V13.75C19.4373 13.75 18.7378 13.4603 18.2221 12.9445C17.7064 12.4288 17.4167 11.7293 17.4167 11C17.4167 10.2707 17.7064 9.57118 18.2221 9.05546C18.7378 8.53973 19.4373 8.25 20.1667 8.25V6.41667C20.1667 5.93044 19.9735 5.46412 19.6297 5.1203C19.2859 4.77649 18.8196 4.58333 18.3333 4.58333H3.66667C3.18044 4.58333 2.71412 4.77649 2.3703 5.1203C2.02649 5.46412 1.83333 5.93044 1.83333 6.41667V8.25Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 11L10.0833 12.8333L13.75 9.16667",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardValidator);
export default __webpack_public_path__ + "static/media/card-validator.a2e83beb432f40e57bf1f0d5934bbb2e.svg";
export { ForwardRef as ReactComponent };